// extracted by mini-css-extract-plugin
export default {"container":"scrollable_container__RZwXF","no-scrollbar":"scrollable_no-scrollbar__WgTNF"};